module.exports = __webpack_public_path__ + "media/assets/images/cba-24fa7180b449593e977e96d136cfe658.png";